function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M10.102 12h11.796a1.5 1.5 0 0 1 1.13 2.488l-5.899 6.74a1.5 1.5 0 0 1-2.117.142c-.073-.068-.073-.068-.14-.142l-5.899-6.74A1.5 1.5 0 0 1 10.103 12z"
});

var SvgDropdownSmall = function SvgDropdownSmall(props) {
  return React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "#1B1F23",
    viewBox: "0 0 32 32"
  }, props), _ref);
};

export default __webpack_public_path__ + "5bc33e77cf65294558765a328991f6bd.svg";
export { SvgDropdownSmall as ReactComponent };


//////////////////
// WEBPACK FOOTER
// ../icons/svg/dropdown-small.svg
// module id = null
// module chunks = 